/**
 * Pantalla encendida (Screen Wake Lock; en web apps instaladas desde iOS 18.4). Con contador, como el
 * IdleTimerManager de iOS: varios usos a la vez no la dejan encendida por error. iOS la suelta al ocultar la app;
 * al volver se pide otra vez si sigue haciendo falta.
 */
let holds = 0;
let lock: WakeLockSentinel | null = null;

async function acquire() {
  if (!('wakeLock' in navigator) || lock || document.visibilityState !== 'visible') return;
  try {
    lock = await navigator.wakeLock.request('screen');
    lock.addEventListener('release', () => { lock = null; });
  } catch { lock = null; }
}

export const wake = {
  hold() { holds += 1; void acquire(); },
  release() {
    holds = Math.max(0, holds - 1);
    if (holds === 0 && lock) { void lock.release().catch(() => {}); lock = null; }
  },
  reset() { holds = 0; if (lock) { void lock.release().catch(() => {}); lock = null; } },
};

document.addEventListener('visibilitychange', () => { if (holds > 0 && document.visibilityState === 'visible') void acquire(); });
